import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class PosLeftNav extends Component {
  render() {
    return(
      <div className="col-sm-5 text-xs-center text-md-left">
        <div className="row no-gutter">
          <div className="col-xs-4"><Link to="/pos" className={'btn btn-secondary waves-effect waves-light pos-left-link ' + (window.location.pathname === '/pos' ? 'active' : '')}>New</Link></div>
          <div className="col-xs-4"><Link to="/pos/openorders" className={'btn btn-secondary waves-effect waves-light pos-left-link ' + (window.location.pathname === '/pos/openorders' ? 'active' : '')}>Open</Link></div>
          <div className="col-xs-4"><Link to="/pos/closedorders" className={'btn btn-secondary waves-effect waves-light pos-left-link ' + (window.location.pathname === '/pos/closedorders' ? 'active' : '')}>Closed</Link></div>
        </div>
      </div>
    );
  }
}

export default PosLeftNav;



// WEBPACK FOOTER //
// ./src/containers/pos_left_nav.js